import { useState } from 'react';

const s = {
  page: {
    minHeight: '100vh',
    background: '#0f1117',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'system-ui, sans-serif',
  },
  card: {
    background: '#181c27',
    border: '1px solid #252a38',
    borderRadius: '12px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '380px',
  },
  logo: {
    color: '#4f8ef7',
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '-0.3px',
    marginBottom: '24px',
  },
  title: {
    color: '#e2e8f0',
    fontSize: '20px',
    fontWeight: '600',
    margin: '0 0 6px',
  },
  subtitle: {
    color: '#64748b',
    fontSize: '13px',
    margin: '0 0 32px',
  },
  label: {
    display: 'block',
    color: '#64748b',
    fontSize: '11px',
    fontWeight: '600',
    letterSpacing: '0.08em',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    background: '#0f1117',
    border: '1px solid #252a38',
    borderRadius: '8px',
    color: '#e2e8f0',
    fontSize: '14px',
    padding: '11px 14px',
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '12px',
  },
  inputFocus: {
    borderColor: '#4f8ef7',
  },
  error: {
    color: '#f87171',
    fontSize: '13px',
    marginBottom: '16px',
    minHeight: '18px',
  },
  button: {
    width: '100%',
    background: '#4f8ef7',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    padding: '12px',
    cursor: 'pointer',
    marginTop: '4px',
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
};

export default function AdminLogin() {
  const [inputKey, setInputKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focused, setFocused] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputKey.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://api.udanchu.com/cards?page=1&limit=1', {
        headers: { 'X-Admin-Key': inputKey },
      });
      if (res.ok) {
        sessionStorage.setItem('udanchu_admin_key', inputKey);
        window.location.reload();
      } else {
        setError('Invalid access key. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>Udanchu</div>
        <h1 style={s.title}>Admin Portal</h1>
        <p style={s.subtitle}>Knowledge Base Management</p>

        <form onSubmit={handleSubmit}>
          <label style={s.label}>ACCESS KEY</label>
          <input
            type="password"
            value={inputKey}
            onChange={e => { setInputKey(e.target.value); setError(''); }}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            style={{ ...s.input, ...(focused ? s.inputFocus : {}) }}
            autoComplete="current-password"
            autoFocus
          />

          <div style={s.error}>{error}</div>

          <button
            type="submit"
            disabled={loading || !inputKey.trim()}
            style={{ ...s.button, ...(loading || !inputKey.trim() ? s.buttonDisabled : {}) }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
